module.exports = __webpack_public_path__ + "img/jo2.07ab9457.png";